<h3 mat-dialog-title>Vermittlernummer: {{data}}</h3>
<div mat-dialog-content>
  <p>Wollen Sie wirklich die Vermittlernummer löschen? Sie können diese Vermittlernummer künftig nicht mehr im Maklerportal nutzen (z.B.: der Zugriff auf Bestands- oder Courtagedaten).", dieser kann mit dem Button ‘Abbrechen‘ ohne Löschung verlassen werden oder mit Button ‘OK‘ bestätigt werden</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Abbrechen</button>
  <button mat-button [mat-dialog-close]="data">Ok</button>
</div>
